import { render } from "./view-details.vue?vue&type=template&id=c796bcc8"
import script from "./view-details.js?vue&type=script&lang=js&external"
export * from "./view-details.js?vue&type=script&lang=js&external"

import "./view-details.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__